import React from 'react'
import { SpinnerCard } from '../common/Layout'
import {
  OrderSummary,
  OrderDetails,
  OrderSummaryLocation
} from '../common/OrderSummary'
import ContactUsSidebar from '../contact-us/ContactUsSidebar'

const SelectedOrder = ({
  order,
  loading,
  submitTicket,
  reasons,
  favorites,
  addFavoriteStart,
  deleteFavoriteStart,
  orderHistorySize
}) => {
  if (order) {
    let props = {
      order,
      submitTicket,
      reasons,
      showForm: true,
      orderHistorySize
    }
    return (
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <SpinnerCard spinnerActive={loading}>
            <OrderSummary>
              <OrderSummaryLocation order={order} orderHistorySize />
              <hr />
              <OrderDetails
                order={order}
                favorites={favorites}
                addFavoriteStart={addFavoriteStart}
                deleteFavoriteStart={deleteFavoriteStart}
              />
            </OrderSummary>
          </SpinnerCard>
        </div>
        <aside className="col-xs-12 col-md-4">
          <ContactUsSidebar
            showForm="true"
            {...props}
            className="contact-us-form"
          />
        </aside>
      </div>
    )
  }

  return null
}

export default SelectedOrder
